import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
  CardReaderInformation,
  CustomerFullInformation,
  CustomerInformationList
} from '../models/customer-information.model';
import { Observable } from 'rxjs';
import { APP, AppResponse } from '../../../shared/models/app.model';
import { getFullUrl } from '../../../shared/utils/utils';
import { endpoint } from '../../../../enviroment/endpoint';
import { environment } from '../../../../enviroment/environment';

@Injectable({
  providedIn: 'root'
})
export class CustomerInformationService {
  httpClient = inject(HttpClient);

  getCustomer(param: any): Observable<AppResponse<CustomerInformationList>> {
    const url = getFullUrl(endpoint.customer.url);
    return this.httpClient.get<AppResponse<CustomerInformationList>>(url, {
      params: param
    });
  }

  getCustomerById(id: string): Observable<AppResponse<CustomerFullInformation>> {
    const headers = new HttpHeaders().set(APP.SPINNER_LOADER, '0');
    const url = getFullUrl(endpoint.customer.url, endpoint.customer.information, { id });
    return this.httpClient.get<AppResponse<CustomerFullInformation>>(url, {
      headers: headers
    });
  }

  saveCustomerInformation(
    customerInformation: CustomerFullInformation
  ): Observable<AppResponse<CustomerFullInformation>> {
    const headers = new HttpHeaders().set(APP.SPINNER_LOADER, '0');
    const url = getFullUrl(endpoint.customer.url, endpoint.customer.save);
    return this.httpClient.post<AppResponse<CustomerFullInformation>>(url, customerInformation, {
      headers: headers
    });
  }

  readCardID() {
    const headers = new HttpHeaders().set(APP.SPINNER_LOADER, '0');
    const url = environment.cardReaderUrl + endpoint.reader.url;
    return this.httpClient.get<CardReaderInformation>(url, {
      headers: headers
    });
  }
}
